import { Dateish, dateTimeShortMonthString } from "src/js/util/dates";
import { differenceInDays, format, formatDistance } from "date-fns";

import { getUserLocale } from "src/js/stores/user/actions/getUserLocale";
import { translate } from "react-migration/lib/i18n/useTranslation";

export const formatRelativeLastOpenedDate = (date?: Dateish | null) => {
  if (!date) return translate("workspaces.last_opened.never");

  const dateObj = new Date(date);
  const now = new Date();
  const daysDiff = differenceInDays(now, dateObj);

  if (daysDiff >= 1) {
    const locale = getUserLocale();
    const dateFormat = locale === "en-US" ? "MM/dd/yyyy, hh:mma" : "dd/MM/yyyy, hh:mma";
    return translate("workspaces.last_opened.ago", {
      date: format(dateObj, dateFormat),
    });
  }

  return translate("workspaces.last_opened.ago", { date: formatDistance(dateObj, now) + " ago" });
};

export const formatExactLastOpenedDate = (date?: Dateish | null) => {
  if (!date) return translate("workspaces.last_opened.never");

  return dateTimeShortMonthString(date);
};
